import { useMemo } from "react";

import type { FileAssetSource } from "../assetTypes.ts";
import { useAssetUrlMap } from "./useAssetUrl.ts";

export const useFileAssetSourceNameToUrlMap = (files: ReadonlyArray<FileAssetSource>) => {
  const assetIds = useMemo(
    (): readonly string[] => files.map(({ assetId }) => assetId).filter((id): id is string => !!id),
    [files],
  );

  const assetUrlMap = useAssetUrlMap(assetIds);

  return useMemo(
    () =>
      new Map<string, string>(
        files
          .filter((f) => f.assetId)
          .map(({ name, assetId }) => [name, assetUrlMap.get(assetId)])
          .filter((e): e is [string, string] => !!e[1]),
      ),
    [files, assetUrlMap],
  );
};
